<template>
    <!-- 主容器 -->
    <div class="app-container">
        <!-- 搜索区域 -->
        <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="80px">
            <!-- 专业名称搜索 -->
            <el-form-item label="专业名称" prop="majorName">
                <el-input v-model="queryParams.majorName" placeholder="请输入专业名称" clearable size="small"
                    @keyup.enter.native="handleQuery" />
            </el-form-item>

            <!-- 所属学院搜索 -->
            <el-form-item label="所属学院" prop="category">
                <el-input v-model="queryParams.category" placeholder="请输入所属学院" clearable size="small"
                    @keyup.enter.native="handleQuery" />
            </el-form-item>

            <!-- 搜索按钮 -->
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">
                    搜索
                </el-button>
                <el-button icon="el-icon-refresh" size="small" @click="resetQuery">
                    重置
                </el-button>
            </el-form-item>
        </el-form>

        <!-- 操作按钮区域 -->
        <el-row :gutter="10" class="mb8">
            <!-- 新增按钮 -->
            <el-col :span="1.5">
                <el-button type="primary" plain icon="el-icon-plus" size="small" @click="handleAdd">
                    新增
                </el-button>
            </el-col>

            <el-col :span="1.5">
                <el-button type="success" plain icon="el-icon-edit" size="mini" :disabled="single"
                    @click="handleUpdate">修改</el-button>
            </el-col>
            <el-col :span="1.5">
                <el-button type="danger" plain icon="el-icon-delete" size="mini" :disabled="multiple"
                    @click="handleDelete">删除</el-button>
            </el-col>
            <el-col :span="1.5">
                <el-button type="warning" plain icon="el-icon-download" size="mini" @click="handleExport">导出</el-button>
            </el-col>
        </el-row>

        <!-- 数据表格 -->
        <el-table v-loading="loading" :data="majorsList" @selection-change="handleSelectionChange"
            class="table-container">
            <!-- 选择列 -->
            <el-table-column type="selection"  align="center" />

            <!-- 专业ID列 -->
            <el-table-column label="专业ID" align="center" prop="majorId"  />

            <!-- 专业名称列 -->
            <el-table-column label="专业名称" align="center" prop="majorName" />

            <!-- 学制列 -->
            <el-table-column label="学制" align="center" prop="majorYear"/>

            <!-- 所属学院列 -->
            <el-table-column label="所属学院" align="center" prop="category" />

            <!-- 操作列 -->
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <!-- 修改按钮 -->
                    <el-button size="mini" type="text" icon="el-icon-edit" @click="handleUpdate(scope.row)">
                        修改
                    </el-button>

                    <!-- 删除按钮 -->
                    <el-button size="mini" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <el-pagination background class="pagination-container" v-show="total > 0" :current-page="queryParams.pageNum"
            :page-sizes="[5, 10, 20, 50]" :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />

        <!-- 新增/编辑对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                <!-- 专业名称输入 -->
                <el-form-item label="专业名称" prop="majorName">
                    <el-input v-model="form.majorName" placeholder="请输入专业名称" />
                </el-form-item>

                <!-- 所属学院选择 -->
                <el-form-item label="所属学院" prop="category">
                    <el-select v-model="form.category" placeholder="请选择所属学院">
                        <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label"
                            :value="item.value" />
                    </el-select>
                </el-form-item>

                <!-- 学制输入 -->
                <el-form-item label="学制" prop="majorYear">
                    <el-input v-model="form.majorYear" placeholder="请输入学制，例如1年制、2年制" />
                </el-form-item>
            </el-form>

            <!-- 对话框底部按钮 -->
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { listMajors, addMajors, updateMajors, delMajors, getMajors } from '@/api/OmdMajors/majors';
import { download } from "@/utils/request";

export default {
    name: "MajorsMain",
    data() {
        return {
            // 加载状态
            loading: true,
            // 选中行的ID数组
            ids: [],
            // 是否单选（用于判断修改按钮状态）
            single: true,
            // 是否多选（用于判断删除按钮状态）
            multiple: true,
            // 是否显示搜索区域
            showSearch: true,
            // 总条数
            total: 0,
            // 专业列表数据
            majorsList: [],
            // 所属学院选项
            categoryOptions: [
                { value: '美妆', label: '美妆' },
                { value: '美发', label: '美发' },
                { value: '美容', label: '美容' },
                { value: '美甲', label: '美甲' },
                { value: '摄影摄像', label: '摄影摄像' },
                { value: '健康管理', label: '健康管理' },
                { value: '其它', label: '其它' },
            ],
            // 对话框标题
            title: "",
            // 是否显示对话框
            open: false,

            // 查询参数
            queryParams: {
                pageNum: 1,       // 当前页码
                pageSize: 10,     // 每页条数
                majorName: null,  // 专业名称
                category: null,   // 所属学院
            },

            // 表单数据
            form: {
                majorId: null,    // 专业ID
                majorName: null,  // 专业名称
                majorYear: null,  // 学制
                category: null   // 所属学院
            },

            // 表单验证规则
            rules: {
                majorName: [
                    { required: true, message: "专业名称不能为空", trigger: "blur" }
                ],
                category: [
                    { required: true, message: "所属学院不能为空", trigger: "change" }
                ],
                majorYear: [
                    { required: true, message: "学制不能为空", trigger: "blur" }
                ]
            }
        };
    },
    created() {
        // 组件创建时获取数据
        this.getList();
    },
    methods: {
        /**
         * 获取专业列表
         * @return {void}
         */
        getList() {
            this.loading = true;
            listMajors(this.queryParams)
                .then(response => {
                    this.majorsList = response.rows;
                    this.total = response.total;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },

        /**
         * 每页条数变化事件
         * @param {number} val 新的每页条数
         * @return {void}
         */
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.getList();
        },

        /**
         * 当前页变化事件
         * @param {number} val 新的页码
         * @return {void}
         */
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getList();
        },

        /**
         * 取消操作（关闭对话框）
         * @return {void}
         */
        cancel() {
            this.open = false;
            this.reset();
        },

        /**
         * 重置表单
         * @return {void}
         */
        reset() {
            this.form = {
                majorId: null,
                majorName: null,
                majorYear: null,
                category: null
            };
            // 重置表单验证状态
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },

        /**
         * 搜索操作
         * @return {void}
         */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },

        /**
         * 重置搜索表单
         * @return {void}
         */
        resetQuery() {
            this.queryParams = {
                pageNum: 1,
                pageSize: 10,
                majorName: null,
                category: null
            };
            this.handleQuery();
        },

        /**
         * 表格选择项变化事件
         * @param {Array} selection 选中的行数据
         * @return {void}
         */
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.majorId);
            this.single = selection.length !== 1;
            this.multiple = !selection.length;
        },

        /**
         * 新增操作
         * @return {void}
         */
        handleAdd() {
            this.reset();
            this.open = true;
            this.title = "添加专业";
        },

        /**
         * 修改操作
         * @param {Object} row 行数据
         * @return {void}
         */
        handleUpdate(row) {
            this.reset();
            const majorId = row.majorId || this.ids[0];

            getMajors(majorId).then(res => {
                this.form=res.data;
                this.open = true;
                this.title = "修改专业";
                console.log("获取专业成功", res.data);
                this.form = res.data;
            })
                .catch(error => {
                    console.error("获取专业详情失败:", error);
                });
        },

        /**
         * 提交表单
         * @return {void}
         */
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    const operation = this.form.majorId ? updateMajors(this.form) : addMajors(this.form);
                    operation.then(response => {
                        this.$modal.msgSuccess(this.form.majorId ? "修改成功" : "新增成功");
                        this.open = false;
                        this.getList();
                        console.log("操作成功:", response);
                    })
                        .catch(error => {
                            console.error("操作失败:", error);
                        });
                }
            });
        },

        /**
         * 删除操作
         * @param {Object|Number} row 行数据或ID
         * @return {void}
         */
        handleDelete(row) {
            const majorIds = row.majorId || this.ids;
            this.$confirm(`是否确认删除编号为"${majorIds}"的专业？`, '警告', {
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                type: 'warning',
                confirmButtonClass: 'confirm-danger-button',
                cancelButtonClass: 'cancel-button'
            })
                .then(() => delMajors(majorIds))
                .then(() => {
                    this.getList();
                    this.$message.success('删除成功');
                })
                .catch(() => { });
        },

        /** 导出按钮操作 */
        handleExport() {
            download('/OmdMajors/majors/export', {
                ...this.queryParams
            }, `专业表_${new Date().getTime()}.xlsx`)
        }
    }
}
</script>

<style scoped>
/* 主容器样式 */
.app-container {
    padding: 20px;
}

/* 表格操作按钮紧凑样式 */
.small-padding .el-button {
    padding: 5px;
    margin-left: 0;
}

/* 表格头部*/
::v-deep .el-table__header-wrapper .el-table__header th {
    background-color: #f4f4f4 !important;
    color: #000 !important;
}

/* 分页器样式 */
::v-deep .el-pager li.active {
    background-color: var(--primary-color) !important;
    color: white !important;
    border-color: var(--primary-color) !important;
    font-weight: bold;
    cursor: pointer;
}

/* 分页器样式 */
::v-deep .el-pager li.active:hover {
    background-color: #d6336c !important;
    color: white !important;
    background-color: #d6336c !important;
    font-weight: bold;
    cursor: pointer;
}

/*按钮的样式 主要按钮 的样式*/
::v-deep .el-button--primary {
    color: #fff;
    background-color: var(--primary-color);
    border: 1px solid var(--primary-color);
}

/*鼠标获得焦点的样式*/
::v-deep .el-button--primary:hover {
    background-color: #d6336c !important;
}

/* 在全局样式文件中添加 */
::v-deep .el-button:focus {
    outline: none !important;
    box-shadow: none !important;
}

/* 如果按钮是 plain 样式 */
::v-deep.el-button--plain:focus {
    outline: none !important;
    box-shadow: none !important;
}

::v-deep .el-button--primary:focus,
.el-button--primary:hover {
    background-color: var(--primary-color);
    border: none;
    color: #fff;
}

/* 文本框鼠标获得焦点边框 */
::v-deep .el-input__inner:focus {
    border-color: var(--primary-color) !important;
}

/* 如果是 textarea */
::v-deep .el-textarea__inner:focus {
    border-color: var(--primary-color) !important;
}

/* 在全局样式或组件样式中添加 */
::v-deep.confirm-delete-button {
    background-color: #f56c6c !important;
    border-color: #f56c6c !important;
}

::v-deep.confirm-delete-button:hover {
    background-color: #e05c5c !important;
    border-color: #e05c5c !important;
}
</style>